import React, { useState, useEffect, useContext } from 'react';



import { FcKindle } from "react-icons/fc";

import Loader from '../../../components/loader/loader';
import { numberFormatter, totalFormatter, decimalFormatter } from '../../../components/formatters/numberFormatter';
import { dateFormatter } from '../../../dynamic/dateFormatter';
import { typeFormatter, paymentTypeFormatter } from '../../../components/formatters/defFormatter';
import { dateTableFormatter } from '../../../dynamic/dateFormatter';
import toast from 'react-hot-toast';
import { FiRotateCcw } from "react-icons/fi";
import { Space, Input, Switch, Button, Spin, Modal, Card, Tabs } from 'antd';

import Select from 'react-select';
import AsyncSelect from 'react-select/async';

import { Col, Form, Row, DropdownButton, Dropdown } from 'react-bootstrap';


import { FiEdit } from "react-icons/fi";
import { FcUndo, FcRefresh, FcFlowChart, FcRules } from "react-icons/fc";
import { BiSolidTrash, BiExport } from "react-icons/bi";
import { IoBarcodeOutline } from "react-icons/io5";
import { FcPlus } from "react-icons/fc";
import { HiMinusCircle } from "react-icons/hi";

import { DataContext } from '../../../init/getData';




function ProductTypes(props) {

  let { type, isDebit } = props;

  const { api, userData, currencyData, settingData, companyId, refData, yearId } = useContext(DataContext);
  const userRole = userData.role;
  const [loadingCounter, setLoadingCounter] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const [loadingEffect, setLoadingEffect] = useState(false);
  const [isSpinning, setIsSpinning] = useState(false);
  const [setting, setSetting] = useState([]);

  const [defaultMultiPrices, setDefaultMultiPrices] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const dataArray = ['setting']
        await refData(dataArray, companyId);
        setIsLoading(false);
      } catch (error) {
        console.error('Error refreshing data Contact Support');
      }
    };
    fetchData();
  }, []);


  useEffect(() => {
    setSetting({
      simpleProduct: settingData.simpleProduct,
      rawMaterialProduct: settingData.rawMaterialProduct,
      compoundProduct: settingData.compoundProduct,
      serializedProduct: settingData.serializedProduct,
      productionProduct: settingData.productionProduct,
      serviceProduct: settingData.serviceProduct,
    })
    setDefaultMultiPrices(settingData.defaultMultiPrices || [])
  }, [isLoading]);


  const handleSubmit = async () => {

    setLoadingEffect(true);

    const data = {
      setting,
      companyId,
      defaultMultiPrices,
    }

    let res = await api.post(`/setting/edit`, data)
    if (res.data.status) {
      toast.success(res.data.message);
      const dataArray = ['setting']
      await refData(dataArray, companyId);
    }
    else {
      toast.error(res.data.message);
    }
    setLoadingEffect(false);
  }


  const handleChange = (name, value) => {
    setSetting((prev) => ({
      ...prev,
      [name]: value,
    }));
  }



  // Add VarientRow
  const handleAddRow = () => {
    setDefaultMultiPrices([...defaultMultiPrices, { name: '', raiseBy: 0 }]);
  };

  // Delete VarientRow
  const handleDeleteRow = (event) => {
    event.preventDefault()
    const updatedRows = defaultMultiPrices.slice(0, -1);
    setDefaultMultiPrices(updatedRows);
  };


  const handlePriceChange = (index, e) => {
    const updatedArray = [...defaultMultiPrices];
    const value = e.target.value;
    const name = e.target.name;
    updatedArray[index][name] = value;
    setDefaultMultiPrices(updatedArray);
  }

  return (
    <div style={{ justifyContent: 'center', alignItems: 'center' }}>

      <Spin spinning={loadingEffect} fullscreen />

      {isLoading &&
        <Loader />
      }

      {!isLoading &&

        <Row className='g-1'>

          <Col md={2}>
          </Col>
          <Col md={4}>

            <Card title={'Types'} >

              <Row className="mb-3">
                <Col md={1}>
                </Col>
                <Col md={6}>
                  <Form.Label>Simple</Form.Label>
                </Col>
                <Col>
                  <Switch style={{ backgroundColor: setting.simpleProduct ? '#23576a' : '#bebfbe' }}
                    checked={setting.simpleProduct}
                    onChange={(e) => handleChange('simpleProduct', e)} />
                </Col>
              </Row>


              <Row className="mb-3">
                <Col md={1}>
                </Col>
                <Col md={6}>
                  <Form.Label>Raw Material</Form.Label>
                </Col>
                <Col>
                  <Switch style={{ backgroundColor: setting.rawMaterialProduct ? '#23576a' : '#bebfbe' }}
                    checked={setting.rawMaterialProduct}
                    onChange={(e) => handleChange('rawMaterialProduct', e)} />
                </Col>
              </Row>


              <Row className="mb-3">
                <Col md={1}>
                </Col>
                <Col md={6}>
                  <Form.Label>Compound</Form.Label>
                </Col>
                <Col>
                  <Switch style={{ backgroundColor: setting.compoundProduct ? '#23576a' : '#bebfbe' }}
                    checked={setting.compoundProduct}
                    onChange={(e) => handleChange('compoundProduct', e)} />
                </Col>
              </Row>


              <Row className="mb-3">
                <Col md={1}>
                </Col>
                <Col md={6}>
                  <Form.Label>Serialized</Form.Label>
                </Col>
                <Col>
                  <Switch style={{ backgroundColor: setting.serializedProduct ? '#23576a' : '#bebfbe' }}
                    checked={setting.serializedProduct}
                    onChange={(e) => handleChange('serializedProduct', e)} />
                </Col>
              </Row>

              <Row className="mb-3">
                <Col md={1}>
                </Col>
                <Col md={6}>
                  <Form.Label>Service</Form.Label>
                </Col>
                <Col>
                  <Switch style={{ backgroundColor: setting.serviceProduct ? '#23576a' : '#bebfbe' }}
                    checked={setting.serviceProduct}
                    onChange={(e) => handleChange('serviceProduct', e)} />
                </Col>
              </Row>


              <Row className="mb-5">
                <Col md={1}>
                </Col>
                <Col md={6}>
                  <Form.Label>Production</Form.Label>
                </Col>
                <Col>
                  <Switch style={{ backgroundColor: setting.productionProduct ? '#23576a' : '#bebfbe' }}
                    checked={setting.productionProduct}
                    onChange={(e) => handleChange('productionProduct', e)} />
                </Col>
              </Row>


              <Row>
                <Col md={5}>
                </Col>
                <Col md={6}>
                  <Button style={{ backgroundColor: '#23576a', color: 'white' }} onClick={handleSubmit}>Save</Button>
                </Col>
              </Row>
            </Card >
          </Col>

          <Col md={4} >

            <Card title={'Multiple Prices'}>

              {defaultMultiPrices.map((row, index) => (
                <div key={index}>
                  {/* Render the labels only for the first row */}
                  {index === 0 && (
                    <Row className="mb-3">
                      <Form.Group as={Col}>
                        <Form.Label>Name</Form.Label>
                      </Form.Group>
                      <Form.Group as={Col}>
                        <Form.Label>RaiseBy</Form.Label>
                      </Form.Group>
                    </Row>
                  )}

                  <Row className="mb-3" style={{ marginTop: '-20px' }}>

                    <Form.Group as={Col}>
                      <Form.Control type="text" name="name"
                        onChange={(e) => handlePriceChange(index, e)}
                        value={row.name}
                        required />
                    </Form.Group>

                    <Form.Group as={Col}>
                      <Form.Control type="number" name="raiseBy"
                        onChange={(e) => handlePriceChange(index, e)}
                        value={row.raiseBy}
                        required />
                    </Form.Group>
                  </Row>

                  <Row key={index + 100} className="mb-3">

                  </Row>
                </div>
              ))}

              <Form.Group
                as={Col}
                style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
              >
                <FcPlus size={26} style={{ cursor: 'pointer' }} onClick={handleAddRow} />
                <HiMinusCircle size={28} style={{ cursor: 'pointer' }} onClick={(e) => handleDeleteRow(e)} />
              </Form.Group>
            </Card >
          </Col>
        </Row>
      }

    </div >


  )
}

export default ProductTypes;
